import { createReducer } from "@reduxjs/toolkit";
import {
  setOpenedAssetsPage,
  setOpenedClientsPage,
  setOpenedVendorsPage,
  setOpenedWashroomLogsPage,
  setPreviousURLTeamMembers,
} from "../actions/openedPages";

interface IOpenedPage {
  openedClientsPage: number;
  openedVendorsPage: number;
  openedAssetsPage: number;
  previousURLTeamMembers: string;
  openedWashroomLogsPage?: number;
}

export const initialState: IOpenedPage = {
  openedClientsPage: 1,
  openedVendorsPage: 1,
  openedAssetsPage: 1,
  previousURLTeamMembers: "",
  openedWashroomLogsPage: 1,
};

export const openedPagesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setOpenedClientsPage, (state, action) => ({
      ...state,
      openedClientsPage: action.payload,
    }))
    .addCase(setPreviousURLTeamMembers, (state, action) => ({
      ...state,
      previousURLTeamMembers: action.payload,
    }))
    .addCase(setOpenedVendorsPage, (state, action) => ({
      ...state,
      openedVendorsPage: action.payload,
    }))
    .addCase(setOpenedAssetsPage, (state, action) => ({
      ...state,
      openedAssetsPage: action.payload,
    }))
    .addCase(setOpenedWashroomLogsPage, (state: IOpenedPage, action: { payload: number }) => ({
      ...state,
      openedWashroomLogsPage: action.payload,
    }));
});
